import { Col, Row } from "antd";
import { useState } from "react";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { useMutation } from "react-query";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

import { getDeliveryApi } from "../../../api/refDelivery";
import { AddEditDelivery } from "./AddEditDelivery";
import DeliveryList from "./deliveryList";

const Deliveries = () => {
  const [openDelivery, setOpenDelivery] = useState(false);
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedtDelivery, setPaginatedtDelivery] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const { mutateAsync: getDeliveriesMutation, isLoading: isGetDeliveriesLoading } =
    useMutation("deliveries", getDeliveryApi);

  const resetFilters = () => {
    const params = {
      limit: page * 8 + 8,
      q: "",
    }
    getDeliveriesMutation(params).then((res: any) => {
      setPaginatedtDelivery(res.data?.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    })
  };

  const handleSearch = () => {
    const params = {
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }
    getDeliveriesMutation(params)
      .then((res: any) => {
        setPaginatedtDelivery(res.data?.data);
      });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    const params = {
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }
    getDeliveriesMutation(params).then((res: any) => {
      setPaginatedtDelivery(res.data?.data);
    })
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenDelivery(true)} />
        </Col>
        <Col span={24}>
          <DeliveryList
            tableKey={tableKey}
            setPage={setPage}
            page={page}
            filter={filter}
            search={search}
            isGetDeliveriesLoading={isGetDeliveriesLoading}
            paginatedtDelivery={paginatedtDelivery}
            setPaginatedtDelivery={setPaginatedtDelivery}
            getDeliveriesMutation={getDeliveriesMutation}
          />
        </Col>
      </Row>
      {openDelivery && (
        <AddEditDelivery
          openDelivery={openDelivery}
          setOpenDelivery={setOpenDelivery}
          setPaginatedtDelivery={setPaginatedtDelivery}
          getDeliveriesMutation={getDeliveriesMutation}
          page={page}
          filter={filter}
          search={search}
        />
      )}
    </>
  );
};

export default Deliveries;
